import React, { useRef, useCallback } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button, Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const SignatureCapture = ({ onSave, onClear }) => {
    const signatureRef = useRef(null);

    const handleClear = () => {
        if (signatureRef.current) {
            signatureRef.current.clear();
            onClear();
        }
    };

    const handleEnd = useCallback(() => {
        if (signatureRef.current && !signatureRef.current.isEmpty()) {
            const signatureImage = signatureRef.current.toDataURL();
            if (signatureImage.length > 1500) {
                onSave(signatureImage);
            } else {
                console.log("La firma es demasiado pequeña y no se considera válida.");
                handleClear();
            }
        }
    }, [onSave, handleClear]);

    return (
        <Grid container alignItems="center" spacing={2} sx={{ marginTop: '5px' }}>
            <Grid item xs={12} sm={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                <SignatureCanvas
                    ref={signatureRef}
                    onEnd={handleEnd}
                    canvasProps={{
                        width: '380vw',
                        height: '150vw',
                        className: 'signatureCanvas',
                        style: {
                            backgroundColor: 'white',
                            margin: '0 20px',
                            border: '4px solid #dbc363',
                        },
                    }}
                />
            </Grid>
            <Grid item xs={12} sm={6} container justifyContent="center" alignItems="center">
                <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    onClick={handleClear}
                    sx={{ backgroundColor: '#6c757d', color: 'white', marginRight: '10px' }}
                >
                    <DeleteIcon />
                </Button>
            </Grid>
        </Grid>
    );
};

export default SignatureCapture;
